// extracted by mini-css-extract-plugin
export default {"arrowUp":"AdditionalInfo_arrowUp__0dQ81","content":"AdditionalInfo_content__72FZD"};